'use strict';

var _ = require('lodash');
var DataRetrieverFactory = function DataRetrieverFactory($log, restangular, $q, $rootScope, currentStateCriteriaService, analysisMetricService, searchCriteriaRsqlQueryService, retrieverConstants, dataService, SearchRule, budgetTargetSearchService, advancedHepSearchService, featureToggleService, searchRulesTransformerService) {
  var fixedSortCriteria = require('../config/fixedSortCriteria.json');
  function DataRetriever(options) {
    this.customSearchCriteria = null;
    this.screen(options.screen);
    this.mode(options.mode);
    this.dataDepth('SHALLOW');
    this.targetType(options.targetType);
    this.isQueryingMoreDomains(options.isQueryingMoreDomains || false);
    this._currentSortBy = options.sortBy || undefined;
    this._currentSortOrder = options.sortOrder || undefined;
    this.ignoredErrorStatuses = options.ignoredErrorStatuses || [];
    this.isTriggeredBySearch = options.isTriggeredBySearch || false;
    this.defaultSortDefer = $q.defer();
    this.defaultSortCriteriaPromise = this.defaultSortDefer.promise;
    this.analysisMetric = analysisMetricService.getAnalysisMetric(this.screen());
    this.requestParameters = options.requestParameters || undefined;
    this._cacheRawData = options.cacheRawData;
    this._scenarios = [];
    this._dataFlow = options.dataFlow || undefined;
    this.noScenario = options.noScenario || false;
    this.httpMethod = options.httpMethod || retrieverConstants.HTTP_METHOD.GET;
    this.mimeType = options.mimeType || undefined;
    this._pageLimit = options.pageLimit || undefined;
    this._dynamicPageLimit = options.dynamicPageLimit;
    this._threadsQuantity = options.threadsQuantity || 1;
    this._maxLimit = options.maxLimit || undefined;
    this._softLimit = options.softLimit || undefined;
    this._multiRequestAllowed = options.multiRequestAllowed || false;
    this.passByRules = options.passByRules || [];
    this.searchRulesTransformConfig = options.searchRulesTransformConfig || {};
  }

  /**
   * Get scenario append function
   * @returns {any}
   */
  DataRetriever.prototype.getScenarioAppendFunction = function () {
    return this.scenarioAppendFunction;
  };

  /**
   * We're adding a function which will append scenario name
   * to search criteria in case it is a string and not an array
   * @param someFunction
   */
  DataRetriever.prototype.setScenarioAppendFunction = function (someFunction) {
    this.scenarioAppendFunction = someFunction;
  };

  /**
   *
   * @param targetType
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.targetType = function (targetType) {
    if (!arguments.length) {
      return this._targetType;
    }
    this._targetType = targetType;
    return this;
  };

  /**
   *
   * @param mode
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.mode = function (mode) {
    if (!arguments.length) {
      return this._mode;
    }
    this._mode = mode;
    return this;
  };

  /**
   *
   * @param dataDepth
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.dataDepth = function (dataDepth) {
    if (!arguments.length) {
      return this._dataDepth;
    }
    this._dataDepth = dataDepth;
    return this;
  };

  /**
   *
   * @param screen
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.screen = function (screen) {
    if (!arguments.length) {
      return this._screen;
    }
    this._screen = screen;
    return this;
  };

  /**
   *
   * @param currentSortOrder
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.currentSortOrder = function (currentSortOrder) {
    if (!arguments.length) {
      return this._currentSortOrder;
    }
    this._currentSortOrder = currentSortOrder;
    return this;
  };

  /**
   *
   * @param brushFilters
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.brushFilters = function (brushFilters) {
    if (!arguments.length) {
      return this._brushFilters;
    }
    this._brushFilters = brushFilters;
    return this;
  };

  /**
   *
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.resetBrushFilters = function () {
    this._brushFilters = {};
    return this;
  };

  /**
   *
   * @param pageLimit
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.currentPageLimit = function (pageLimit) {
    if (!arguments.length) {
      return this._pageLimit;
    }
    this._pageLimit = pageLimit;
    return this;
  };

  /**
   *
   * @param threadsQuantity
   * @return {*}
   */
  DataRetriever.prototype.threadsQuantity = function (threadsQuantity) {
    if (!arguments.length) {
      return this._threadsQuantity;
    }
    this._threadsQuantity = threadsQuantity;
    return this;
  };

  /**
   *
   * @param requestParameters
   * @return {*}
   */
  DataRetriever.prototype.currentRequestParameters = function (requestParameters) {
    if (!arguments.length) {
      return this.requestParameters;
    }
    this.requestParameters = requestParameters;
    return this;
  };

  /**
   *
   * @param currentSortBy
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.currentSortBy = function (currentSortBy) {
    if (!arguments.length) {
      return this._currentSortBy;
    }
    this._currentSortBy = currentSortBy;
    return this;
  };

  /**
   *
   * @param selectedMetric
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.selectedMetric = function (selectedMetric) {
    if (!arguments.length) {
      return this.selMetric;
    }
    this.selMetric = selectedMetric;
    return this;
  };
  DataRetriever.prototype.selectedDimension = function (dimension) {
    if (!arguments.length) {
      return this.selDimension;
    }
    this.selDimension = dimension;
    return this;
  };
  DataRetriever.prototype.selectedParams = function (params) {
    if (!arguments.length) {
      return this.selParams;
    }
    this.selParams = _.extend(this.selParams, params);
    return this;
  };

  /**
   *
   * @param {Array.<string>} scenarios
   */
  DataRetriever.prototype.scenarios = function (scenarios) {
    if (scenarios) {
      this._scenarios = scenarios;
    } else {
      return this._scenarios;
    }
    return this;
  };

  /**
   *
   * @param {string} dataFlow
   */
  DataRetriever.prototype.dataFlow = function (dataFlow) {
    if (dataFlow) {
      this._dataFlow = dataFlow;
    } else {
      return this._dataFlow;
    }
    return this;
  };

  /**
   * Returns or sets requirement to query additional domains
   * @param isQuerying
   * @returns {*}
   */
  DataRetriever.prototype.isQueryingMoreDomains = function (isQuerying) {
    if (!arguments.length) {
      return this._isQueryingMoreDomains;
    }
    this._isQueryingMoreDomains = isQuerying;
    return this;
  };
  DataRetriever.prototype.setCustomSearchCriteriaRules = function (customSearchCriteria) {
    this.customSearchCriteria = customSearchCriteria;
    return this;
  };
  DataRetriever.prototype.setRequestParameters = function (requestParameters) {
    this.requestParameters = requestParameters;
    return this;
  };

  /**
   *
   * @returns {*}
   * @private
   */
  DataRetriever.prototype.getSearchCriteriaRules = function () {
    return this.customSearchCriteria || currentStateCriteriaService.getSearchCriteriaRulesForRsqlQuery();
  };

  /**
   *
   * @returns {*}
   * @public
   */
  DataRetriever.prototype.resetCustomSearchCriteriaRules = function () {
    this.customSearchCriteria = null;
    return this;
  };
  DataRetriever.prototype.getRestangularService = function (sourceType) {
    sourceType = sourceType || this.mode();
    return getRestangularBySourceType(sourceType, this.selectedParams());
  };

  /**
   *
   * @param sourceType
   * @returns {string}
   * @private
   */
  DataRetriever.prototype.getDataUrl = function (sourceType) {
    var isPostDepartureMode = currentStateCriteriaService.isPostDeparture() || false;
    var C = retrieverConstants; //only for code readability
    var params = this.selectedParams();
    switch (sourceType) {
      case C.MARKET_MODE:
      case C.MARKET_POST_DEPARTURE_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedMarketDemandPOS').getRestangularUrl() + '?dataDepth=SHALLOW';
      case C.SPONSOR_FORECAST_MARKET_MODE:
        return restangular.one('configured').one('marketDemand').all('flattenedMarketDemandPOS').getRestangularUrl();
      case C.SPONSOR_FORECAST_LEG_MODE:
        return restangular.one('configured').one('flights').all('flattenedAggregatedLegs').getRestangularUrl();
      case C.SPONSOR_FORECAST_FLIGHT_MODE:
        return restangular.one('ancillary').all('legmarketschedule');
      case C.MARKET_PRODUCT_GROUP_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedMarketDemandClassGroupPOS').getRestangularUrl() + '?dataDepth=' + this.dataDepth();
      case C.MARKET_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedPOSCurveDetails').getRestangularUrl();
      case C.MARKET_PRODUCT_GROUP_BOOKINGS_INTAKE_MODE:
      case C.MARKET_PRODUCT_GROUP_PROFILE_GRAPH_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedClassGroupCurveDetails').getRestangularUrl();
      case C.BOOKING_MATRIX_MODE:
        return restangular.one('domain').one('services').all('bookingClassMatrix').getRestangularUrl() + '/' + (featureToggleService.isEnabled('MAPPED_MODE') ? 'REGULAR' : 'MAPPED');
      case C.ADJUSTMENT_HISTORY_MODE:
        return restangular.one('adjustmentsHistory').all('selectedObject').getRestangularUrl() + '/' + params.adjustmentsHistoryDomain + '/' + params.objectId;
      case C.SYSTEM_STATUS_HISTORY_MODE:
        return restangular.one('adjustmentsHistory').all('searchHistory').getRestangularUrl() + '/' + params.adjustmentsHistoryDomain;
      case C.SERVICE_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('services').all('flattenedServiceClassPOSCurveDetails').getRestangularUrl();
      case C.SERVICE_MANAGEMENT_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('services').all('flattenedServicePOSCurveDetails').getRestangularUrl();
      case C.SERVICE_MODE:
      case C.SERVICE_SHARE_MODE:
      case C.SERVICE_POST_DEPARTURE_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('services').all('flattenedServiceClassPOS').getRestangularUrl() + '?dataDepth=SHALLOW' : restangular.one('domain').one('services').all('flattenedServiceClassPOS').getRestangularUrl() + '?dataDepth=SHALLOW';
      case C.SERVICE_COMPETITOR_FARE_MODE:
      case C.MARKET_PRODUCT_COMPETITOR_FARE_MODE:
      case C.FLIGHT_COMPETITOR_FARE_MODE:
        return restangular.one('configured').all('compFareCurve').getRestangularUrl();
      case C.CABIN_MODE:
      case C.CABIN_DA_MODE:
        return restangular.one('domain').one('flights').all('flattenedLegCabins').getRestangularUrl() + '?dataDepth=SHALLOW';
      case C.CABIN_BOOKINGS_INTAKE_MODE:
      case C.FLIGHT_CABIN_PROFILE_MODE:
        return restangular.one('domain').one('flights').all('flattenedLegCabinsCurveDetails').getRestangularUrl();
      case C.CABIN_POST_DEPARTURE_MODE:
        return restangular.one('configured').one('flights').all('flattenedLegCabins').getRestangularUrl() + '?dataDepth=' + this.dataDepth();
      case C.CABIN_DEEP_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('flights').all('flattenedLegCabins').getRestangularUrl() + '?dataDepth=DEEP' : restangular.one('domain').one('flights').one('flattenedLegCabins').all('detailed').getRestangularUrl();
      case C.CLASS_BOOKINGS_INTAKE_MODE:
      case C.FLIGHT_CLASS_PROFILE_MODE:
        return restangular.one('domain').one('flights').all('flattenedLegClassCurveDetails').getRestangularUrl();
      case C.SEGMENT_CLASS_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('flights').all('flattenedSegmentClassCurveDetails').getRestangularUrl();
      case C.CLASS_MODE:
      case C.CLASS_POST_DEPARTURE_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('flights').all('flattenedLegClasses').getRestangularUrl() : restangular.one('domain').one('flights').one('mergedlegclasssegclass').getRestangularUrl();
      case C.FLIGHT_CABIN_ALERTS:
        return restangular.one('domain').one('flights').one('alerts').all('cabin').getRestangularUrl();
      case C.FLIGHT_CABIN_ALERTS_CLEAR:
        return restangular.one('domain').one('flights').one('alerts').one('cabin').all('clear').getRestangularUrl();
      case C.FLIGHT_CLASS_ALERTS:
        return restangular.one('domain').one('flights').one('alerts').all('legClass').getRestangularUrl();
      case C.FLIGHT_CLASS_ALERTS_CLEAR:
        return restangular.one('domain').one('flights').one('alerts').one('legClass').all('clear').getRestangularUrl();
      case C.FLIGHT_SEGMENT_CLASS_ALERTS:
        return restangular.one('domain').one('flights').one('alerts').all('segmentClass').getRestangularUrl();
      case C.FLIGHT_SEGMENT_CLASS_ALERTS_CLEAR:
        return restangular.one('domain').one('flights').one('alerts').one('segmentClass').all('clear').getRestangularUrl();
      case C.MARKET_SERVICE_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('serviceClass').getRestangularUrl();
      case C.MARKET_SERVICE_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').one('serviceClass').all('clear').getRestangularUrl();
      case C.SERVICE_MANAGEMENT_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('serviceClass').getRestangularUrl();
      case C.SERVICE_MANAGEMENT_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').all('serviceClass').all('clear').getRestangularUrl();
      case C.MARKET_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('pos').getRestangularUrl();
      case C.MARKET_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').one('pos').all('clear').getRestangularUrl();
      case C.MARKET_PRODUCT_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('classGroup').getRestangularUrl();
      case C.MARKET_PRODUCT_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').one('classGroup').all('clear').getRestangularUrl();
      case C.SEGMENT_CLASS_MODE:
      case C.SEGMENT_CLASS_POST_DEPARTURE_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('flights').all('flattenedSegmentClasses').getRestangularUrl() : restangular.one('domain').one('flights').all('flattenedSegmentClasses').getRestangularUrl();
      case C.DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE:
        return restangular.one('domain').one('demand').all('flattenedExtendedUntruncatedMarketDemand').getRestangularUrl();
      case C.DEMAND_TRANSPARENCY_INITIAL_FORECAST_PROFILE:
        return restangular.one('configuration').one('hep').all('key').getRestangularUrl();
      case C.DEMAND_TRANSPARENCY_FORECAST_PROFILE_REGULAR:
        return restangular.one('configuration').one('hep').all('marketinitdemandprofile').getRestangularUrl() + '?type=REGULAR';
      case C.DEMAND_TRANSPARENCY_FORECAST_PROFILE_MAPPED:
        return restangular.one('configuration').one('hep').all('marketinitdemandprofile').getRestangularUrl() + '?type=MAPPED';
      case C.STRATEGY_LISTING_MODE:
        return restangular.one('rules').all('strategy').getRestangularUrl() + '?filter=type==optimization';
      case C.ALERT_STRATEGY_LISTING_MODE:
        return restangular.one('rules').all('strategy').getRestangularUrl() + '?filter=type==alert';
      case C.RULE_CUSTOM_STRATEGY_LISTING:
        return restangular.one('rules').all('strategy').getRestangularUrl() + '?filter=isQuickRule==false;type==optimization' + appendFlowTypeExclusion(params);
      case C.RULE_CUSTOM_STRATEGY_LISTING_ALERTS:
        return restangular.one('rules').all('strategy').getRestangularUrl() + '?filter=isQuickRule==false;type==alert' + appendFlowTypeExclusion(params);
      case C.RULE_SCHEDULE_CHANGE_REVIEW_MODE:
        return restangular.one('rules').getRestangularUrl();
      case C.RULE_LISTING_MODE:
        return restangular.one('rules').getRestangularUrl() + '?filter=isUserOverride==false;type==optimization';
      case C.ALERT_RULE_LISTING_MODE:
        return restangular.one('rules').getRestangularUrl() + '?filter=isUserOverride==false;type==alert';
      case C.COMPLETED_MODE:
        return restangular.one('extract').all('completed').getRestangularUrl();
      case C.SCHEDULED_MODE:
        return restangular.one('extract').all('scheduled').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_MODE:
        return restangular.one('configuration').all('hepSimple').getRestangularUrl() + '?engineCategory=' + params.type;
      case C.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE:
        return params.isDefault ? restangular.one('configuration').one('hep').all('defaults').getRestangularUrl() + '?type=' + params.type : restangular.one('configuration').all('hepAdvanced').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE:
        return restangular.one('staticdata').all('targets').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_ENTITY_MODE:
        return restangular.one('staticdata').all('entity').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_EVENTS_MODE:
        return restangular.one('configuration').one('hep').all('specialEvent').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_FLIGHT_TAG_MODE:
        return restangular.one('domain').all('flightTags').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_DISCONTINUED_ROUTES_MODE:
        return restangular.one('domain').all('discontinuedRoute').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_MARKET_ASSIGN_MODE:
        return restangular.one('configuration').one('hep').all('marketentityassignment').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_FLIGHT_ASSIGN_MODE:
        return restangular.one('configuration').one('hep').all('flightentityassignment').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_LEG_ASSIGN_MODE:
        return restangular.one('configuration').one('hep').all('legentityassignment').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_HOST_SHARE_MODE:
        return restangular.one('configuration').one('hep').all('hostshare').getRestangularUrl();
      case C.SYSTEM_STATUS_USER_EXCLUSION_RULES_MODE:
        return restangular.one('external').all('priceExclusion').getRestangularUrl();
      case C.SYSTEM_STATUS_USER_FBC_EXCLUSION_RULES_MODE:
        return restangular.one('external').all('priceFBCExclusion').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_INFLUENCES_MODE:
        return restangular.one('external').all('mcposAverageFaresOverride').getRestangularUrl();
      case C.SYSTEM_STATUS_USER_FO_FARE_EXCLUSION_RULES_MODE:
        return restangular.one('external').one('faresoptimizer').all('fareexclusionrules').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_FO_LINKED_FBC_MODE:
        return restangular.one('external').one('faresoptimizer').all('linkedfbc').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_FO_MARKETS_MODE:
        return restangular.one('external').one('faresoptimizer').all('fomarkets').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_FO_CITYAPTS_MODE:
        return restangular.one('external').one('faresoptimizer').all('focityapts').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_FARE_BUILDER_MODE:
        return restangular.one('external').one('faresoptimizer').all('fareBuilder').getRestangularUrl();
      case C.SYSTEM_REOPTIMIZATION_STATUS_MODE:
        return restangular.one('status').all('processingDays').getRestangularUrl();
      case C.SYSTEM_STATUS_FIGHT_REOPT_MODE:
        return restangular.one('queue').one('BomNDRequest').one('messages').all('bomQueue').getRestangularUrl();
      case C.SYSTEM_STATUS_FARES_REOPT_MODE:
        return restangular.one('queue').one('FaresOptimizerReopt').one('messages').all('faresOptimizerReoptQueues').getRestangularUrl();
      case C.SYSTEM_STATUS_DEMAND_REINITIALIZATION_MODE:
        return restangular.one('queue').one('DemandInitWorkload').one('messages').all('demandInitWorkloadQueue').getRestangularUrl();
      case C.SYSTEM_STATUS_OVERBOOKING_MODE:
        return restangular.one('queue').one('ShowUpInitWorkload').one('messages').all('showUpInitWorkloadQueue').getRestangularUrl();
      case C.SYSTEM_STATUS_FLIGHT_SENT_MODE:
        return restangular.one('queue').one('SendSSIRequest').one('messages').all('sendSSIRequest').getRestangularUrl();
      case C.SYSTEM_STATUS_SERVICE_SENT_MODE:
        return restangular.one('queue').one('SendNewSkiesRequest').one('messages').all('sendNewSkiesRequest').getRestangularUrl();
      case C.SYSTEM_STATUS_INTERFACE_STATUS_MODE:
        return restangular.one('queue').one('InterfaceQueues').one('messages').all('interfacestatus').getRestangularUrl();
      case C.FARES_MODE:
        return restangular.one('external').all('flattenedActiveFares').getRestangularUrl();
      case C.FARES_CHART_MODE:
        return restangular.one('external').all('flattenedrevenueaccounting').getRestangularUrl();
      case C.FARES_AVERAGE_MODE:
      case C.FARES_PREV_AVERAGE_MODE:
      case C.FARES_INVERSION_MODE:
        return restangular.one('domain').all('flattenedMcposAverageFare').getRestangularUrl();
      case C.MAPPED_FARES_MODE:
      case C.MAPPED_FARES_INVERSION_MODE:
        return restangular.one('domain').all('flattenedMcposMappedFare').getRestangularUrl();
      case C.CONTRIBUTING_SERVICES_MODE:
        return restangular.one('domain').one('segmentToServiceMap').all('flattened').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_MODE:
        return restangular.one('domain').all('flattenedMcposAverageFare').getRestangularUrl() + '?filter=spos==Default';
      case C.SURCHARGE_UPLOAD_MODE:
        return restangular.one('domain').all('surcharge').all('flattened').getRestangularUrl() + (featureToggleService.isEnabled('FIM') ? '' : '?spos=Default');
      case C.MARKET_DASHBOARD_MODE:
        return restangular.one('domain').all('marketmonthmetrics').getRestangularUrl();
      case C.FIM_DASHBOARD_MODE:
        return restangular.one('domain').all('marketmonthfimalerts').getRestangularUrl();
      case C.SEASONALITY_SHOW_UP_MODE:
        return restangular.one('partitioned/seasonality').all('showupcalendars').getRestangularUrl();
      case C.SEASONALITY_DEMAND_MODE:
        return restangular.one('partitioned/seasonality').all('demandcalendars').getRestangularUrl();
      case C.SEASONALITY_POOLED_MODE:
        return restangular.one('pooled/seasonality').all('calendars').getRestangularUrl();
      case C.APPLICABLE_SEASONS:
        return restangular.one('partitioned/seasonality').all('analysis').all('seasons').getRestangularUrl();
      case C.SEASONALITY_ANALYSIS_CHART_HISTORICAL:
        return restangular.one('partitioned/seasonality').all('analysis').getRestangularUrl();
      case C.SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED:
        return restangular.one('pooled/seasonality').all('analysis').getRestangularUrl();
      case C.SEASONALITY_ANALYSIS_CHART_FUTURE:
        return restangular.one('partitioned/seasonality').all('futureAnalysis').getRestangularUrl();
      case C.SEASONALITY_ANALYSIS_CHART_FUTURE_POOLED:
        return restangular.one('pooled/seasonality').all('futureAnalysis').getRestangularUrl();
      case C.SEASONALITY_UNTRUNCATED_MD_MODE:
        return restangular.one('domain').one('demand').all('flattenedWeeklyUntruncatedMarketDemand').getRestangularUrl();
      case C.ROM_ANALYSIS_LOCO_MODE:
        return restangular.one('rom').all('lowestclassopen').getRestangularUrl();
      case C.ROM_ANALYSIS_DEMAND_PAX_MODE:
        return restangular.one('rom').all('serviceclasssposoptgroup').getRestangularUrl();
      case C.ROM_ANALYSIS_FLATTENED_SERVICES_MODE:
        return restangular.one('rom').all('flattenedmarketcabinsposoptgroup').getRestangularUrl();
      case C.ROM_ANALYSIS_SKINNY_SERVICES_MODE:
      case C.ROM_ANALYSIS_SKINNY_SERVICES_REFERENCE_MODE:
        return restangular.one('rom').one('marketcabinsposoptgroup').all('skinny').getRestangularUrl();
      case C.ROM_SUMMARY_MODE:
      case C.ROM_SUMMARY_REFERENCE_MODE:
        return restangular.one('rom').one('marketcabinsposoptgroup').all('summary').getRestangularUrl();
      case C.ROM_SUMMARY_TOP_OPP_RECAP_MODE:
        return restangular.one('rom').all('recaptureoptgroupweekopportunity').getRestangularUrl();
      case C.ROM_SUMMARY_TOP_OPP_SPILL_MODE:
        return restangular.one('rom').all('spilloptgroupweekopportunity').getRestangularUrl();
      case C.USER_MANAGEMENT_MANAGE_USERS_MODE:
        return restangular.one('users').all('nonadminusers').getRestangularUrl();
      case C.USER_MANAGEMENT_ROLE_MANAGEMENT_MODE:
        return restangular.one('users').all('nonadminroles').getRestangularUrl();
      case C.USER_MANAGEMENT_DEFAULT_ROLE_VIEW_MODE:
      case C.USER_MANAGEMENT_ROLES_MODE:
        return restangular.one('configuration').all('hep').getRestangularUrl() + '?type=ComponentApiMap';
      case C.USER_MANAGEMENT_MANAGE_ACCESS_REQUESTS_MODE:
        return restangular.one('users').all('nonadminusers').getRestangularUrl() + '?filter=isActive==false';
      case C.SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET_MODE:
        return restangular.one('configuration').all('hep').getRestangularUrl() + '?type=UserDefinedReferenceDataMarketProfile';
      case C.SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_FLIGHT_MODE:
        return restangular.one('configuration').all('hep').getRestangularUrl() + '?type=UserDefinedReferenceDataFlightProfile';
      case C.PRICING_ANALYSIS_DEPARTURE_DATES:
        return restangular.one('external').one('priceRecommendation').all('networkAnalysis').getRestangularUrl();
      case C.PRICING_ANALYSIS_SERVICES:
        return restangular.one('external').one('priceRecommendation').all('networkAnalysisServices').getRestangularUrl();
      case C.PRICING_SUMMARY_SNAPSHOT_DATES:
        return restangular.one('external').one('priceRecommendation').all('summary').getRestangularUrl();
      case C.PRICING_SUMMARY_FARE_CHANGE:
        return restangular.one('external').one('priceRecommendation').all('summaryDetail').getRestangularUrl();
      case C.MARKET_PRODUCT_GROUP_MAPPED_BOOKINGS_MODE:
        return restangular.one('domain').one('services').all('marketproductaggregatedtripbookings').getRestangularUrl();
      case C.MARKET_MAPPED_BOOKINGS_MODE:
        return restangular.one('domain').one('services').all('marketaggregatedtripbookings').getRestangularUrl();
      case C.FARES_BASIS_GROUPS_MODE:
        return restangular.one('external').all('farebasisgroup').getRestangularUrl();
      case C.GLOBAL_NOTIFICATIONS_MODE:
        return restangular.one('global').all('notifications').getRestangularUrl();
      case C.FARES_INTERLINE_FARES_ADJUSTMENT:
        return restangular.one('external').all('partnerAdjustments').getRestangularUrl();
      case C.DEMAND_SHARES_MODE:
        return restangular.one('domain').all('logitCalibration').getRestangularUrl();
      default:
        $log.warn('Unable to create URL for source type: ', sourceType);
        return '';
    }
  };

  /**
   *
   * @param searchCriteriaRules
   * @returns {*}
   * @private
   */
  function getDomainRsqlQuery(searchCriteriaRules) {
    if (_.isString(searchCriteriaRules)) {
      return searchCriteriaRules;
    }
    return searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules(searchCriteriaRules);
  }

  /**
   *
   * @param newMetric
   * @private
   */
  DataRetriever.prototype.updateMetricValues = function (newMetric) {
    this.selectedMetric(newMetric);
    this.metrics = this.analysisMetric.getMetricValues(this.mode(), this.selectedMetric(), this.targetType(), this.selectedDimension());
    var eventParts = [this._screen, this._mode];
    if (this._targetType) {
      eventParts.push(this._targetType);
    }
    $rootScope.$broadcast(eventParts.join('-') + ':metricChanged', this.selectedMetric());
    return this;
  };

  /**
   *
   * @param dimension
   * @private
   */
  DataRetriever.prototype.updateDimensionValues = function (dimension) {
    this.selectedDimension(dimension);
    this.metrics = this.analysisMetric.getMetricValues(this.mode(), this.selectedMetric(), this.targetType(), this.selectedDimension());
    var eventParts = [this._screen, this._mode];
    if (this._targetType) {
      eventParts.push(this._targetType);
    }
    $rootScope.$broadcast(eventParts.join('-') + ':dimensionChanged', this.selectedDimension());
    return this;
  };
  DataRetriever.prototype.updateAdditionalParameters = function (parameters) {
    this.selectedParams(parameters);
    return this;
  };

  /**
   * Data source object definition used for specifying misc attributes
   * @return  {*}
   */
  DataRetriever.prototype.createDataSource = function (rsqlQuery, url, sort, disableDynamicPageLimit) {
    return {
      url: url || this.getDataUrl(this.mode()),
      rsqlQuery: rsqlQuery,
      pageLimit: this.currentPageLimit(),
      sortBy: sort ? sort.sortBy : this.currentSortBy(),
      sortOrder: sort ? sort.sortOrder : this.currentSortOrder(),
      requestParameters: this.currentRequestParameters(),
      dynamicPageLimit: disableDynamicPageLimit ? false : this._dynamicPageLimit,
      threadsQuantity: disableDynamicPageLimit ? 1 : this._threadsQuantity,
      //thread page limit in this case will be pageLimit parameter
      httpMethod: this.httpMethod,
      mimeType: this.mimeType,
      ignoredErrorStatuses: this.ignoredErrorStatuses,
      maxLimit: this._maxLimit,
      softLimit: this._softLimit,
      multiRequestAllowed: this._multiRequestAllowed
    };
  };
  DataRetriever.prototype.getMetricDescriptor = function () {
    return {
      metric: this.selectedMetric(),
      dimension: this.selectedDimension(),
      params: this.selectedParams(),
      toString: function toString() {
        return this.metric + '-' + this.dimension;
      }
    };
  };
  function createScenarioRule(scenarioName) {
    return new SearchRule({
      metaCategory: 'customScenarioRules',
      field: 'scenarioName',
      operator: '=',
      leftOperand: scenarioName
    });
  }
  function createDataFlowRule(dataFlow) {
    return new SearchRule({
      metaCategory: 'customDataFlowRules',
      field: 'pointOfSales.flowType',
      operator: '=',
      leftOperand: dataFlow
    });
  }
  function appendFlowTypeExclusion(params) {
    var appendix = '';
    if (params && params.flowTypeToExclude) {
      _.forEach(params.flowTypeToExclude, function (flowType) {
        appendix += ';flowType!=' + flowType;
      });
    }
    return appendix;
  }
  function getAdditionalDomainDataSource(self, domainMode, searchCriteriaRules) {
    var dataSource;
    var url = self.getDataUrl(domainMode);
    var isTargetBudget = domainMode === retrieverConstants.SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE;
    var isAdvancedHep = domainMode === retrieverConstants.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE;
    if (isTargetBudget) {
      var targetRsqlQuery = budgetTargetSearchService.createBudgetTargetSearchRule(searchCriteriaRules);
      dataSource = self.createDataSource(targetRsqlQuery, url, {}, true);
    } else if (isAdvancedHep) {
      var parametersAdvancedQuery = advancedHepSearchService.createAdditionalHepSearchRule(searchCriteriaRules);
      dataSource = self.createDataSource(parametersAdvancedQuery, url);
    } else {
      var rsqlQuery = getDomainRsqlQuery(self.filterSearchCriteriaRules(searchCriteriaRules));
      dataSource = self.createDataSource(rsqlQuery, url);
    }
    dataSource.httpMethod = retrieverConstants.HTTP_METHOD.GET;
    dataSource.mimeType = undefined;
    return dataSource;
  }
  DataRetriever.prototype.filterSearchCriteriaRules = function (rules) {
    if (!_.size(this.passByRules)) {
      return rules;
    }
    var self = this;
    return _.filter(rules, function (rule) {
      return _.find(self.passByRules, {
        criteriaName: rule.criterion,
        fieldName: rule.field,
        categoryName: rule.category
      });
    });
  };
  function prepareRsqlQuery(rules, self) {
    var rsqlOverride = currentStateCriteriaService.getRsqlOverride(self._mode);
    return rsqlOverride ? rsqlOverride : getDomainRsqlQuery(self.filterSearchCriteriaRules(rules));
  }
  function prepareSearchRules(self, scenariosNames, rules) {
    // for flight analysis and market analysis - add PUBLISHED
    if (!self.noScenario && scenariosNames && scenariosNames.length) {
      if (_.isArray(rules)) {
        rules = rules.concat(createScenarioRule(scenariosNames[0]));
      } else {
        rules = self.getScenarioAppendFunction()(rules, scenariosNames[0]);
      }
    }

    // for market analysis - add data flow - REGULAR or MAPPED
    if (self.dataFlow()) {
      rules = rules.concat(createDataFlowRule(self.dataFlow()));
    }

    // transform search criteria rules when they are needed
    _.each(self.searchRulesTransformConfig, function (args, transformer) {
      if (_.isFunction(searchRulesTransformerService[transformer])) {
        var callArgs = _.cloneDeep(args);
        callArgs.unshift(rules);
        rules = searchRulesTransformerService[transformer].apply(null, callArgs);
      }
    });
    return rules;
  }
  function prepareDataSourcesAndSearchRules(dataSources, self, searchCriteriaRules, scenariosNames, rules) {
    //for querying additional domains
    if (self.isQueryingMoreDomains()) {
      var queryingMoreDomainsMap = require('../config/queryingMoreDomainsMap.json');
      var additionalDomains = queryingMoreDomainsMap[self.mode()];
      additionalDomains.forEach(function (domainMode) {
        dataSources.push(getAdditionalDomainDataSource(self, domainMode, searchCriteriaRules));
      });
    }

    // for flight analysis and market analysis - add selected scenario
    if (!self.noScenario && scenariosNames && scenariosNames.length > 1) {
      if (_.isArray(rules)) {
        rules = searchCriteriaRules.concat(createScenarioRule(scenariosNames[1]));
      } else {
        rules = self.getScenarioAppendFunction()(searchCriteriaRules, scenariosNames[1]);
      }
      dataSources.push(self.createDataSource(getDomainRsqlQuery(self.filterSearchCriteriaRules(rules))));
    }
    return rules;
  }

  /**
   *
   * @param targetType
   * @param searchCriteriaRules
   * @returns {*|string}
   * @private
   */
  DataRetriever.prototype.retrieveData = function (targetType, searchCriteriaRules) {
    var self = this;
    var scenariosNames = this.scenarios();
    var rules = searchCriteriaRules;
    rules = prepareSearchRules(self, scenariosNames, rules);
    var rsqlQuery = prepareRsqlQuery(rules, self);
    var dataSources = [this.createDataSource(rsqlQuery, undefined, fixedSortCriteria[this.mode()])];
    rules = prepareDataSourcesAndSearchRules(dataSources, self, searchCriteriaRules, scenariosNames, rules);
    var metricDescriptor = this.getMetricDescriptor();
    var screenModeConfig = {
      screen: this._screen,
      mode: this._mode
    };
    return dataService.getData(this.mode(), targetType, this.getFilters(), this.getMetrics(), dataSources, this._cacheRawData, metricDescriptor, screenModeConfig);
  };

  /**
   * Retrieves the data using provided RQL query string.
   * @param targetType
   * @param rqlQuery
   * @param parameters
   * @returns {*|string}
   * @private
   */
  DataRetriever.prototype.retrieveDataWithRql = function (targetType, rqlQuery, parameters) {
    var dataSource = this.createDataSource(rqlQuery);
    if (parameters) {
      var url = dataSource.url;
      parameters.forEach(function (param) {
        url = url.one(param);
      });
      dataSource.url = url.getRestangularUrl();
    }
    return dataService.getData(this.mode(), targetType, [], [], [dataSource], this._cacheRawData);
  };

  /**
   * Return current selected brushes
   * @returns {Array}
   * @public
   */
  DataRetriever.prototype.getFilters = function () {
    return _.chain(this.brushFilters()).clone(true).values().value();
  };

  /**
   * Return dataKey property of the metrics
   * @returns {Array}
   * @public
   */
  DataRetriever.prototype.getMetrics = function () {
    return this.analysisMetric.getDataKeys(this.mode(), this.selectedMetric(), this.targetType(), this.selectedDimension());
  };

  /**
   * This method is call to set sorting parameters. Simplified version of gridSortApplied.
   * Till it is not called (and defaultSortCriteriaPromise is resolved) retrieveComponentData doesn't return data
   * @public
   */
  DataRetriever.prototype.localSortApplied = function () {
    this.currentSortBy(this._currentSortBy);
    this.currentSortOrder(this._currentSortOrder);
    this.defaultSortDefer.resolve();
    return this;
  };

  /**
   * This method is call to set sorting parameters.
   * Till it is not called (and defaultSortCriteriaPromise is resolved) retrieveComponentData doesn't return data
   * @param sort
   * @public
   */
  DataRetriever.prototype.gridSortApplied = function (sort) {
    this.currentSortBy(sort.getFieldsAsString());
    this.currentSortOrder(sort.getDirsAsString());
    this.defaultSortDefer.resolve();
  };

  /**
   * This message is called from different components (charts, grids, etc)
   * to get promise of the data (retrieved from RestAPI)
   * @param targetType
   * @param [selectedMetric]
   * @param [dimension]
   * @returns {Promise|*}
   * @public
   */
  DataRetriever.prototype.retrieveComponentData = function (targetType, selectedMetric, dimension) {
    var dataRetriever = this;
    if (selectedMetric && selectedMetric !== this.selectedMetric()) {
      this.updateMetricValues(selectedMetric);
    }
    if (dimension && dimension !== this.selectedDimension()) {
      this.updateDimensionValues(dimension);
    }
    return $q.all([dataRetriever.getSearchCriteriaRules(), dataRetriever.defaultSortCriteriaPromise]).then(function (promisesResults) {
      var searchCriteriaRules = promisesResults[0];
      return dataRetriever.retrieveData(targetType, searchCriteriaRules, dimension);
    }).then(function (data) {
      //triggering if only there is no brushes because brush is empty on search
      if (dataRetriever.isTriggeredBySearch && _.isEmpty(dataRetriever.brushFilters())) {
        if (data.length === 0) {
          $rootScope.$broadcast('search-criteria:no-results');
        }
      }
      return data;
    });
  };

  /**
   * The simplified version of retrieveComponentData that uses provided RQL query.
   * @param targetType
   * @param rqlQuery
   * @param parameters
   * @returns {Promise|*}
   * @public
   */
  DataRetriever.prototype.retrieveSimpleData = function (targetType, rqlQuery, parameters) {
    return this.retrieveDataWithRql(targetType, rqlQuery, parameters);
  };
  function getRestangularBySourceType(sourceType, params) {
    var isPostDepartureMode = currentStateCriteriaService.isPostDeparture() || false;
    var C = retrieverConstants; //only for code readability

    switch (sourceType) {
      case C.MARKET_MODE:
      case C.MARKET_POST_DEPARTURE_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedMarketDemandPOS');
      case C.SPONSOR_FORECAST_MARKET_MODE:
        return restangular.one('configured').one('marketDemand').all('flattenedMarketDemandPOS');
      case C.SPONSOR_FORECAST_LEG_MODE:
        return restangular.one('configured').one('flights').all('flattenedAggregatedLegs');
      case C.SPONSOR_FORECAST_FLIGHT_MODE:
        return restangular.one('ancillary').all('legmarketschedule');
      case C.MARKET_PRODUCT_GROUP_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedMarketDemandClassGroupPOS');
      case C.MARKET_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedPOSCurveDetails');
      case C.MARKET_PRODUCT_GROUP_BOOKINGS_INTAKE_MODE:
      case C.MARKET_PRODUCT_GROUP_PROFILE_GRAPH_MODE:
        return restangular.one('domain').one('marketdemand').all('flattenedClassGroupCurveDetails');
      case C.BOOKING_MATRIX_MODE:
        return restangular.one('domain').one('services').all('bookingClassMatrix');
      case C.ADJUSTMENT_HISTORY_MODE:
        return restangular.one('adjustmentsHistory').all('selectedObject');
      case C.SYSTEM_STATUS_HISTORY_MODE:
        return restangular.one('adjustmentsHistory').all('searchHistory');
      case C.SERVICE_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('services').all('flattenedServiceClassPOSCurveDetails');
      case C.SERVICE_MANAGEMENT_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('services').all('flattenedServicePOSCurveDetails');
      case C.SERVICE_MODE:
      case C.SERVICE_SHARE_MODE:
      case C.SERVICE_POST_DEPARTURE_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('services').all('flattenedServiceClassPOS') : restangular.one('domain').one('services').all('flattenedServiceClassPOS');
      case C.SERVICE_COMPETITOR_FARE_MODE:
      case C.MARKET_PRODUCT_COMPETITOR_FARE_MODE:
      case C.FLIGHT_COMPETITOR_FARE_MODE:
        return restangular.one('configured').all('compFareCurve');
      case C.CABIN_MODE:
        return restangular.one('domain').one('flights').all('flattenedLegCabins');
      case C.CABIN_BOOKINGS_INTAKE_MODE:
      case C.FLIGHT_CABIN_PROFILE_MODE:
        return restangular.one('domain').one('flights').all('flattenedLegCabinsCurveDetails');
      case C.CABIN_POST_DEPARTURE_MODE:
        return restangular.one('configured').one('flights').all('flattenedLegCabins');
      case C.CABIN_DEEP_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('flights').all('flattenedLegCabins') : restangular.one('domain').one('flights').one('flattenedLegCabins').all('detailed');
      case C.CLASS_BOOKINGS_INTAKE_MODE:
      case C.FLIGHT_CLASS_PROFILE_MODE:
        return restangular.one('domain').one('flights').all('flattenedLegClassCurveDetails');
      case C.SEGMENT_CLASS_BOOKINGS_INTAKE_MODE:
        return restangular.one('domain').one('flights').all('flattenedSegmentClassCurveDetails');
      case C.CLASS_MODE:
      case C.CLASS_POST_DEPARTURE_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('flights').all('flattenedLegClasses') : restangular.one('domain').one('flights').one('mergedlegclasssegclass');
      case C.FLIGHT_CABIN_ALERTS:
        return restangular.one('domain').one('flights').one('alerts').all('cabin');
      case C.FLIGHT_CABIN_ALERTS_CLEAR:
        return restangular.one('domain').one('flights').one('alerts').one('cabin').all('clear');
      case C.FLIGHT_CLASS_ALERTS:
        return restangular.one('domain').one('flights').one('alerts').all('legClass');
      case C.FLIGHT_CLASS_ALERTS_CLEAR:
        return restangular.one('domain').one('flights').one('alerts').one('legClass').all('clear');
      case C.FLIGHT_SEGMENT_CLASS_ALERTS:
        return restangular.one('domain').one('flights').one('alerts').all('segmentClass');
      case C.FLIGHT_SEGMENT_CLASS_ALERTS_CLEAR:
        return restangular.one('domain').one('flights').one('alerts').one('segmentClass').all('clear');
      case C.MARKET_SERVICE_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('serviceClass');
      case C.MARKET_SERVICE_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').one('serviceClass').all('clear');
      case C.SERVICE_MANAGEMENT_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('serviceClass');
      case C.SERVICE_MANAGEMENT_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').all('serviceClass').all('clear');
      case C.MARKET_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('pos');
      case C.MARKET_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').one('pos').all('clear');
      case C.MARKET_PRODUCT_ALERTS:
        return restangular.one('domain').one('marketdemand').one('alerts').all('classGroup');
      case C.MARKET_PRODUCT_ALERTS_CLEAR:
        return restangular.one('domain').one('marketdemand').one('alerts').one('classGroup').all('clear');
      case C.SEGMENT_CLASS_MODE:
      case C.SEGMENT_CLASS_POST_DEPARTURE_MODE:
        return isPostDepartureMode ? restangular.one('configured').one('flights').all('flattenedSegmentClasses') : restangular.one('domain').one('flights').all('flattenedSegmentClasses');
      case C.DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE:
        return restangular.one('domain').one('demand').all('flattenedExtendedUntruncatedMarketDemand');
      case C.DEMAND_TRANSPARENCY_INITIAL_FORECAST_PROFILE:
        return restangular.one('configuration').one('hep').all('key');
      case C.DEMAND_TRANSPARENCY_FORECAST_PROFILE_REGULAR:
        return restangular.one('configuration').one('hep').all('marketinitdemandprofile');
      case C.DEMAND_TRANSPARENCY_FORECAST_PROFILE_MAPPED:
        return restangular.one('configuration').one('hep').all('marketinitdemandprofile');
      case C.STRATEGY_LISTING_MODE:
        return restangular.one('rules').all('strategy');
      case C.ALERT_STRATEGY_LISTING_MODE:
        return restangular.one('rules').all('strategy');
      case C.RULE_CUSTOM_STRATEGY_LISTING:
        return restangular.one('rules').all('strategy');
      case C.RULE_CUSTOM_STRATEGY_LISTING_ALERTS:
        return restangular.one('rules').all('strategy');
      case C.RULE_SCHEDULE_CHANGE_REVIEW_MODE:
        return restangular.one('rules');
      case C.RULE_LISTING_MODE:
        return restangular.one('rules');
      case C.ALERT_RULE_LISTING_MODE:
        return restangular.one('rules');
      case C.COMPLETED_MODE:
        return restangular.one('extract').all('completed');
      case C.SCHEDULED_MODE:
        return restangular.one('extract').all('scheduled');
      case C.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_MODE:
        return restangular.one('configuration').all('hepSimple');
      case C.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE:
        return params.isDefault ? restangular.one('configuration').one('hep').all('defaults') : restangular.one('configuration').all('hepAdvanced');
      case C.SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE:
        return restangular.one('staticdata').all('targets');
      case C.SYSTEM_STATUS_CONFIGURATION_ENTITY_MODE:
        return restangular.one('staticdata').all('entity');
      case C.SYSTEM_STATUS_CONFIGURATION_EVENTS_MODE:
        return restangular.one('configuration').one('hep').all('specialEvent');
      case C.SYSTEM_STATUS_CONFIGURATION_FLIGHT_TAG_MODE:
        return restangular.one('domain').all('flightTags').getRestangularUrl();
      case C.SYSTEM_STATUS_CONFIGURATION_MARKET_ASSIGN_MODE:
        return restangular.one('configuration').one('hep').all('marketentityassignment');
      case C.SYSTEM_STATUS_CONFIGURATION_FLIGHT_ASSIGN_MODE:
        return restangular.one('configuration').one('hep').all('flightentityassignment');
      case C.SYSTEM_STATUS_CONFIGURATION_LEG_ASSIGN_MODE:
        return restangular.one('configuration').one('hep').all('legentityassignment');
      case C.SYSTEM_STATUS_CONFIGURATION_HOST_SHARE_MODE:
        return restangular.one('configuration').one('hep').all('hostshare');
      case C.SYSTEM_STATUS_USER_EXCLUSION_RULES_MODE:
        return restangular.one('external').all('priceExclusion');
      case C.SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_INFLUENCES_MODE:
        return restangular.one('external').all('mcposAverageFaresOverride');
      case C.SYSTEM_STATUS_USER_FO_FARE_EXCLUSION_RULES_MODE:
        return restangular.one('external').one('faresoptimizer').all('fareexclusionrules');
      case C.SYSTEM_STATUS_CONFIGURATION_FO_LINKED_FBC_MODE:
        return restangular.one('external').one('faresoptimizer').all('linkedfbc');
      case C.SYSTEM_STATUS_CONFIGURATION_FO_MARKETS_MODE:
        return restangular.one('external').one('faresoptimizer').all('fomarkets');
      case C.SYSTEM_STATUS_CONFIGURATION_FO_CITYAPTS_MODE:
        return restangular.one('external').one('faresoptimizer').all('focityapts');
      case C.SYSTEM_REOPTIMIZATION_STATUS_MODE:
        return restangular.one('status').all('processingDays');
      case C.SYSTEM_STATUS_FIGHT_REOPT_MODE:
        return restangular.one('queue').one('BomNDRequest').one('messages').all('bomQueue');
      case C.SYSTEM_STATUS_FARES_REOPT_MODE:
        return restangular.one('queue').one('FaresOptimizerReopt').one('messages').all('faresOptimizerReoptQueues');
      case C.SYSTEM_STATUS_DEMAND_REINITIALIZATION_MODE:
        return restangular.one('queue').one('DemandInitWorkload').one('messages').all('demandInitWorkloadQueue');
      case C.SYSTEM_STATUS_OVERBOOKING_MODE:
        return restangular.one('queue').one('ShowUpInitWorkload').one('messages').all('showUpInitWorkloadQueue');
      case C.SYSTEM_STATUS_FLIGHT_SENT_MODE:
        return restangular.one('queue').one('SendSSIRequest').one('messages').all('sendSSIRequest');
      case C.SYSTEM_STATUS_SERVICE_SENT_MODE:
        return restangular.one('queue').one('SendNewSkiesRequest').one('messages').all('sendNewSkiesRequest');
      case C.SYSTEM_STATUS_INTERFACE_STATUS_MODE:
        return restangular.one('queue').one('InterfaceQueues').one('messages').all('interfacestatus');
      case C.FARES_MODE:
        return restangular.one('external').all('flattenedActiveFares');
      case C.FARES_CHART_MODE:
        return restangular.one('external').all('flattenedrevenueaccounting');
      case C.FARES_AVERAGE_MODE:
      case C.FARES_PREV_AVERAGE_MODE:
      case C.FARES_INVERSION_MODE:
        return restangular.one('domain').all('flattenedMcposAverageFare');
      case C.MAPPED_FARES_MODE:
      case C.MAPPED_FARES_INVERSION_MODE:
        return restangular.one('domain').all('flattenedMcposMappedFare');
      case C.CONTRIBUTING_SERVICES_MODE:
        return restangular.one('domain').one('segmentToServiceMap').all('flattened');
      case C.SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_MODE:
        return restangular.one('domain').all('flattenedMcposAverageFare');
      case C.SURCHARGE_UPLOAD_MODE:
        return restangular.one('domain').all('surcharge').all('flattened');
      case C.MARKET_DASHBOARD_MODE:
        return restangular.one('domain').all('marketmonthmetrics');
      case C.FIM_DASHBOARD_MODE:
        return restangular.one('domain').all('marketmonthfimalerts');
      case C.SEASONALITY_SHOW_UP_MODE:
        return restangular.one('seasonality').all('showupcalendars');
      case C.SEASONALITY_DEMAND_MODE:
        return restangular.one('seasonality').all('demandcalendars');
      case C.APPLICABLE_SEASONS:
        return restangular.one('seasonality').all('analysis').all('seasons');
      case C.SEASONALITY_ANALYSIS_CHART_HISTORICAL:
        return restangular.one('seasonality').all('analysis');
      case C.SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED:
        return restangular.one('pooled/seasonality').all('analysis').getRestangularUrl();
      case C.SEASONALITY_ANALYSIS_CHART_FUTURE:
        return restangular.one('seasonality').all('futureAnalysis');
      case C.SEASONALITY_ANALYSIS_CHART_FUTURE_POOLED:
        return restangular.one('pooled/seasonality').all('futureAnalysis').getRestangularUrl();
      case C.SEASONALITY_UNTRUNCATED_MD_MODE:
        return restangular.one('domain').one('demand').all('flattenedWeeklyUntruncatedMarketDemand');
      case C.ROM_ANALYSIS_LOCO_MODE:
        return restangular.one('rom').all('lowestclassopen');
      case C.ROM_ANALYSIS_DEMAND_PAX_MODE:
        return restangular.one('rom').all('serviceclasssposoptgroup');
      case C.ROM_ANALYSIS_FLATTENED_SERVICES_MODE:
        return restangular.one('rom').all('flattenedmarketcabinsposoptgroup');
      case C.ROM_ANALYSIS_SKINNY_SERVICES_MODE:
      case C.ROM_ANALYSIS_SKINNY_SERVICES_REFERENCE_MODE:
        return restangular.one('rom').one('marketcabinsposoptgroup').all('skinny');
      case C.ROM_SUMMARY_MODE:
      case C.ROM_SUMMARY_REFERENCE_MODE:
        return restangular.one('rom').one('marketcabinsposoptgroup').all('summary');
      case C.ROM_SUMMARY_TOP_OPP_RECAP_MODE:
        return restangular.one('rom').all('recaptureoptgroupweekopportunity');
      case C.ROM_SUMMARY_TOP_OPP_SPILL_MODE:
        return restangular.one('rom').all('spilloptgroupweekopportunity');
      case C.USER_MANAGEMENT_MANAGE_USERS_MODE:
        return restangular.one('users').all('nonadminusers');
      case C.USER_MANAGEMENT_ROLE_MANAGEMENT_MODE:
        return restangular.one('users').all('nonadminroles');
      case C.USER_MANAGEMENT_DEFAULT_ROLE_VIEW_MODE:
      case C.USER_MANAGEMENT_ROLES_MODE:
        return restangular.one('configuration').all('hep');
      case C.USER_MANAGEMENT_MANAGE_ACCESS_REQUESTS_MODE:
        return restangular.one('users').all('nonadminusers');
      case C.SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET_MODE:
        return restangular.one('configuration').all('hep');
      case C.SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_FLIGHT_MODE:
        return restangular.one('configuration').all('hep');
      case C.PRICING_ANALYSIS_DEPARTURE_DATES:
        return restangular.one('external').one('priceRecommendation').all('networkAnalysis');
      case C.PRICING_ANALYSIS_SERVICES:
        return restangular.one('external').one('priceRecommendation').all('networkAnalysisServices');
      case C.PRICING_SUMMARY_SNAPSHOT_DATES:
        return restangular.one('external').one('priceRecommendation').all('summary');
      case C.PRICING_SUMMARY_FARE_CHANGE:
        return restangular.one('external').one('priceRecommendation').all('summaryDetail');
      case C.MARKET_PRODUCT_GROUP_MAPPED_BOOKINGS_MODE:
        return restangular.one('domain').one('services').all('marketproductaggregatedtripbookings');
      case C.MARKET_MAPPED_BOOKINGS_MODE:
        return restangular.one('domain').one('services').all('marketaggregatedtripbookings');
      case C.FARES_BASIS_GROUPS_MODE:
        return restangular.one('external').all('farebasisgroup');
      case C.GLOBAL_NOTIFICATIONS_MODE:
        return restangular.one('global').all('notifications');
      case C.FARES_INTERLINE_FARES_ADJUSTMENT:
        return restangular.one('external').all('partnerAdjustments');
      case C.DEMAND_SHARES_MODE:
        return restangular.one('domain').all('logitCalibration');
      default:
        $log.warn('Unable to create URL for source type: ', sourceType);
        return '';
    }
  }
  return DataRetriever;
};
DataRetrieverFactory.$inject = ['$log', 'Restangular', '$q', '$rootScope', 'CurrentStateCriteriaService', 'AnalysisMetricService', 'SearchCriteriaRsqlQueryService', 'DataRetrieverConstantsService', 'DataService', 'SearchCriteriaRuleFactory', 'BudgetTargetSearchService', 'AdvancedHepSearchService', 'FeatureToggleService', 'DataRetrieverSearchRulesTransformerService'];
module.exports = DataRetrieverFactory;